@if (showSpinner) {
  <div class="overlaySpinner">
    <div class="spinner-loading">
      <div class="querySpinner">
        <img src="/assets/img/logo-C.png" alt="logoCosta" class="logo-costa">
        <span class="spinner-double-dot-stick"></span>
      </div>
    </div>
  </div>
}
